import { Dumbbell, BookOpen, Palette, Shirt, Dribbble, BookX, Gamepad2, Sandwich, Briefcase, UtensilsCrossed, Salad, Gift, Trophy, Ticket, Star, Music, Camera, Pizza, Coffee, Headphones } from 'lucide-react';

export const ITEM_ICONS = {
  dumbbell: Dumbbell, 'book-open': BookOpen, palette: Palette, shirt: Shirt, dribbble: Dribbble, 'book-x': BookX,
  gamepad: Gamepad2, sandwich: Sandwich, briefcase: Briefcase, utensils: UtensilsCrossed, salad: Salad, gift: Gift,
  trophy: Trophy, ticket: Ticket, star: Star, music: Music, camera: Camera, pizza: Pizza, coffee: Coffee, headphones: Headphones,
};
